/* eslint-disable */

import { Formik } from "formik";
import { useState } from "react";
import DropDownInput from "../../../../Universal/DropDownInput.component";
import FormInput from "../../../../Universal/FormInput.component";
import DatePicker from "../../../../Universal/DatePicker.component";
import MemberFormValidation from "../../../Organizational/Management/Members/MemberFormValidation.component";

const AddLiabilitiesModel = () => {
  const [submittedValues, setSubmittedValues] = useState(null);
  const processSlotsList = [
    "Monthly",
    "Quarterly",
    "Yearly",
    "Bi-Annually",
    "Weekly",
  ];
  const timeDuration = [
    "1 month",
    "3 months",
    "6 months",
    "1 year",
    "2 years",
    "5 years",
    "10 years",
  ];
  return (
    <Formik
      initialValues={{
        liability: "",
        timeDuration: "",
        totalAmount: "",
        firstTimePayment: "",
        date: "",
        slottedPayment: "",
        processSlots: "",
      }}
      validationSchema={MemberFormValidation} // Validation schema
      onSubmit={(values) => {
        console.log("Form Submitted:", values); // Log the values
        setSubmittedValues(values); // Store the submitted values in state
      }}
    >
      {({ setFieldValue, handleSubmit, touched, errors, setTouched }) => {
        console.log(errors);

        return (
          <form onSubmit={handleSubmit} className="liabilitiesForm">
            <h3 className="addLiabilitiesFormTitle">Add Liabilities</h3>

            <div className="AddLiabilitiesFormInputs">
              <div className="memberAddFormTextInputs">
                <FormInput
                  type="text"
                  name="liability"
                  touched={touched}
                  errors={errors}
                  placeholder="Enter liability title"
                  label="Liability"
                  setFieldValue={(e) =>
                    setFieldValue("liability", e.target.value)
                  }
                />

                <DropDownInput
                  name="timeDuration"
                  label="Time duration"
                  setFieldValue={(val) => setFieldValue("timeDuration", val)}
                  placeholder={"Choose designation"}
                  suggestionList={timeDuration}
                  errors={errors}
                  setTouched={(name, isTouched) =>
                    setTouched({ [name]: isTouched })
                  }
                  touched={touched}
                />
                <FormInput
                  label="Total Amount"
                  type="number"
                  name="totalAmount"
                  touched={touched}
                  errors={errors}
                  placeholder="Enter total payable amount"
                  setFieldValue={(e) =>
                    setFieldValue("totalAmount", e.target.value)
                  }
                />
                <FormInput
                  label="First time payment(INR)"
                  type="number"
                  name="firstTimePayment"
                  touched={touched}
                  errors={errors}
                  placeholder="Enter first time payment amount"
                  setFieldValue={(e) =>
                    setFieldValue("firstTimePayment", e.target.value)
                  }
                />

                <DatePicker
                  label="First time payment"
                  name="firstTimePaymentDate"
                  setFieldValue={(val) => setFieldValue("date", val)}
                  placeholder={"Choose Date"}
                  errors={errors}
                />
                <FormInput
                  label="Slotted payment(INR)"
                  type="number"
                  name="slottedPayment"
                  touched={touched}
                  errors={errors}
                  placeholder="Enter first time payment amount"
                  setFieldValue={(e) =>
                    setFieldValue("slottedPayment", e.target.value)
                  }
                />
                <DropDownInput
                  name="processSlots"
                  label="Process slots"
                  setFieldValue={(val) => setFieldValue("processSlots", val)}
                  placeholder={"Choose payment slot"}
                  suggestionList={processSlotsList}
                  errors={errors}
                  touched={touched}
                  setTouched={(name, isTouched) =>
                    setTouched({ [name]: isTouched })
                  }
                />
                <button type="submit" className="liabilityFormSubmitBtn">
                  Add Liabilities
                </button>
              </div>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};

export default AddLiabilitiesModel;
